import { observable, computed } from 'mobx';
import { ViewController } from '@estee/elc-service';
import { HoverZoom } from '~domain/entities/HoverZoom';

export class ProductHoverZoomViewController extends ViewController {
    @observable hoverZoom: HoverZoom;
    @observable isZoomActive: boolean = false;

    constructor(hoverZoom: HoverZoom) {
        super();
        this.hoverZoom = hoverZoom;
    }

    @computed
    get data() {
        return {
            isZoomActive: this.zoomActiveStatus,
            currentZoomSlideIndex: this.currentSlideIndex
        };
    }

    @computed
    public get zoomActiveStatus(): boolean {
        return this.hoverZoom.isZoomActive;
    }

    @computed
    public get currentSlideIndex(): number {
        return this.hoverZoom.currentZoomSlideIndex;
    }

    public setCurrentZoomSlideIndex = (currentZoomSlideIndex: number = 0) => {
        this.hoverZoom.setCurrentZoomSlideIndex(currentZoomSlideIndex);
    };

    public closeZoom = () => {
        this.hoverZoom.closeZoom();
    };
}
